import { FormPublic } from '@goldcast/api/backend';

import { Template, State } from './types';

import router from '@/router';
import { FieldMappingBooleans } from '@/studio/orgIntegration/store/types';

const getters = {
  getTemplates(state: State): Array<Template> {
    return Object.values(state.templates);
  },
  getTemplateById: (state: State) => (templateId: string) => {
    return state.templates[templateId];
  },
  getCurrentTemplate(state: State): Template | undefined {
    if (state.templates[state.currentTemplateId]) {
      return state.templates[state.currentTemplateId];
    }
  },
  getTemplateRegistrationFormInfo(_, getters): FormPublic {
    const currentTemplate = getters['getCurrentTemplate'];
    return currentTemplate?.registration_form_data;
  },
  isTemplateInstance(state: State): boolean {
    const path = router?.currentRoute?.value?.path?.toLowerCase();
    return state.currentTemplateId !== '' && path.startsWith('/templates');
  },
  areThereInvalidTemplateFieldMapping(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes;
    const areThereInvalidFieldMapping = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      areThereInvalidFieldMapping[crm_object_type] =
        state.templateFieldMappingRowError?.[crm_object_type]?.some(
          rowError =>
            rowError && (rowError.code === 'MISSING_TARGET_FIELD' || rowError.code === 'MISSING_TEMPLATE_SOURCE_FIELD')
        ) || false;
    });
    return areThereInvalidFieldMapping;
  },
  areThereTemplateFieldMappingError(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes;
    const areThereFieldMappingError = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      areThereFieldMappingError[crm_object_type] = state.templateFieldMappingRowError[crm_object_type].some(
        rowError => rowError !== null
      );
    });
    return areThereFieldMappingError;
  },
  areThereTemplateFieldMappingChanges(state: State, _, rootState): FieldMappingBooleans {
    const crmObjectTypes = rootState?.orgIntegration?.crmObjectTypes;
    const areThereFieldMappingChanges = {};
    crmObjectTypes.forEach(({ crm_object_type }) => {
      if (
        state.templateFieldMappings[crm_object_type].mappings.length !==
        state.prevTemplateFieldMappings[crm_object_type].length
      ) {
        areThereFieldMappingChanges[crm_object_type] = true;
        return;
      }
      areThereFieldMappingChanges[crm_object_type] = state.templateFieldMappings[crm_object_type].mappings.some(
        (fieldMapping, index) =>
          JSON.stringify(fieldMapping) !== JSON.stringify(state.prevTemplateFieldMappings[crm_object_type][index])
      );
    });
    return areThereFieldMappingChanges;
  }
};

export default getters;
